class ProductDropdownAttributes {
  constructor() {
    this.dropdownContainerSelector = ".js-product-attribute-dropdown";
    this.selectSelector = ".js-product-attribute-dropdown-select";
    this.dropdownBtnSelector = ".js-product-attribute-dropdown-btn";
    this.dropdownMenuSelectorElement = ".js-product-attribute-dropdown-link";
    this.handleSelectReset = this.handleSelectReset.bind(this);
    this.handleDropdownElementClick = this.handleDropdownElementClick.bind(this);
    this.prestashopEventAttached = false;
    this.triggerMailAlert = false;
  }
  init() {
    this.bindEvents();
  }
  bindEvents() {
    if (!this.prestashopEventAttached) {
      prestashop.on("productAttributesSelectReseted", this.handleSelectReset);
      prestashop.on("updatedProduct", () => {
        setTimeout(() => {
          if (this.triggerMailAlert) {
            $(".js-mailalert-modal").trigger("click");
            this.triggerMailAlert = false;
          }
        }, 1);
      });
      this.prestashopEventAttached = true;
    }
    $(this.dropdownMenuSelectorElement).off("click", this.handleDropdownElementClick).on("click", this.handleDropdownElementClick);
  }
  handleDropdownElementClick(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const key = $target.data("key");
    const $relatedSelect = $target.closest(this.dropdownContainerSelector).find(this.selectSelector);
    const $selectedOption = $relatedSelect.find(`[data-key=${key}]`);
    const selectedOptionVal = $selectedOption.val();
    $relatedSelect.val(selectedOptionVal).trigger("change");
    if ($target.hasClass("js-trigger-mailalert")) {
      this.triggerMailAlert = true;
    } else {
      this.triggerMailAlert = false;
    }
  }
  handleSelectReset({select, $appendedPlaceholder}) {
    const $select = $(select);
    const $relatedDropdownBtn = $select.closest(this.dropdownContainerSelector).find(this.dropdownBtnSelector);
    const $relatedDropdownElements = $relatedDropdownBtn.find(this.dropdownMenuSelectorElement);
    $relatedDropdownBtn.html(`${$appendedPlaceholder.text()}<span class="collapse-icon"></span>`);
    $relatedDropdownElements.removeClass("product-attribute-dropdown__item--selected");
  }
}
export default ProductDropdownAttributes;
